import { render, staticRenderFns } from "./u-text-field-outlined-rounded.vue?vue&type=template&id=d87e5b30&scoped=true&"
import script from "./u-text-field-outlined-rounded.vue?vue&type=script&lang=js&"
export * from "./u-text-field-outlined-rounded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d87e5b30",
  null
  
)

export default component.exports